export const messagesError = {
    pt: {
        message:{
            atLeastTwoOptions: "São necessárias pelo menos duas opções na pesquisa.",
            attributesOpacity: "Você não pode ter mais de dois atributos com opacidade menor que 50%.",
            borderOrBackgroundActive: "A opção precisa ter pelo menos a borda ou o fundo ativo.",
            confirmNewPassword: "Confirme a nova senha",
            copyContent: "Não foi possível copiar o código",
            enterCurrentPassword: "Informe a senha atual",
            enterEmail: "Informe o e-mail",
            enterName: "Informe o nome",
            enterNewPassword: "Informe a nova senha",
            enterPostAuthPage: "Informe a página pós-autenticação",
            fileToBig: "O arquivo selecionado excede o limite de tamanho permitido. O limite máximo é de ",
            integrationServiceUnavailable: "Serviço de Integração Indisponível",
            interactionMustHaveName: "A interação precisa ter nome.",
            invalidFileFormat: "Formato de arquivo inválido",
            invalidTime: "Horário inválido",
            loadImage: "Erro ao carregar, certifique-se de que a imagem está carregada e tente novamente.",
            loadLocalsError: "Não foi possível carregar a lista de locais. Tente novamente.",
            loadEstablishmentsError: "Não foi possível carregar a lista de estabelecimentos. Tente novamente.",
            passwordsDontMatch: "Nova senha e confirmação não coincidem",
            selectAutomationFlow: "Selecione um fluxo de automação",
            selectDatabase: "Selecione um banco de dados",
            selectDate: "Selecione uma data",
            selectEntryCriteria: "Selecione o critério de entrada",
            selectExternalService: "Selecione o serviço externo",
            selectFieldType: "Selecione o tipo do campo",
            selectFile: "É necessário selecionar um arquivo",
            selectList: "É preciso selecionar uma das listas segmentadas",
            selectTrackerType: "Selecione o tipo do rastreador",
            selectVoucher: "Selecione o voucher",
            selectEstablishmentWeight: "Selecione um peso para o estabelecimento",
            smsContentAtLeatsTwoCharacters: "O conteúdo da mensagem deve ter pelo menos dois caractéres",
            timeoutValue: "Tempo de conexão deve ser de pelo menos 15 minutos",
            optionTwoCharacters: "Cada opção precisa ter pelo menos dois caractéres"

        }
    },
    es: {
        message:{
            atLeastTwoOptions:"Al menos se necesitan dos opciones en la encuesta",
            attributesOpacity:"No se puede tener más de dos atributos con opacidad inferior al 50%",
            borderOrBackgroundActive:"La opción debe tener al menos el borde o el fondo activo",
            confirmNewPassword:"Confirme la nueva contraseña",
            copyContent: "No se puede copiar el código",
            enterCurrentPassword:"Ingrese la contraseña actual",
            enterEmail:"Ingrese con el correo electrónico",
            enterName:"Ingrese el nombre",
            enterNewPassword:"Ingrese la nueva contraseña",
            enterPostAuthPage:"Ingrese la página posterior a la autorización",
            fileToBig:"El archivo seleccionado excede el límite de tamaño permitido. El límite máximo es de ",
            integrationServiceUnavailable: "Servicio de integración no disponible",
            interactionMustHaveName:"La interacción debe tener un nombre",
            invalidFileFormat: "Formato de archivo no válido",
            invalidTime: "Hora invalida",
            loadImage:"Error de carga, asegúrese de que la imagen esté cargada y vuelva a intentarlo",
            loadLocalsError: "No se pudo cargar la lista de locales. Inténtelo de nuevo.",
            loadEstablishmentsError: "No se pudo cargar la lista de establecimientos. Inténtelo de nuevo.",
            passwordsDontMatch:"Nueva contraseña y confirmación no coinciden",
            selectAutomationFlow: "Seleccione un flujo de automatización",
            selectDatabase: "Seleccione una base de datos",
            selectDate: "Selecciona una fecha",
            selectEntryCriteria: "Seleccionar criterio de entrada",
            selectExternalService: "Seleccionar servicio externo",
            selectFieldType: "Seleccionar tipo de campo",
            selectFile:"Es necesario seleccionar un archivo",
            selectList:"Necesita seleccionar una de las listas segmentadas",
            selectTrackerType: "Seleccione el tipo de rastreador",
            selectVoucher: "Seleccionar el vale",
            selectEstablishmentWeight: "Seleccione un peso para el establecimiento",
            smsContentAtLeatsTwoCharacters: "El contenido del mensaje debe tener al menos dos caracteres",
            timeoutValue: "El tiempo de conexión debe ser de al menos 15 minutos.",
            optionTwoCharacters:"Cada opción debe tener al menos dos caractéres"
        }
    },
    en: {
        message:{
            atLeastTwoOptions: "At least two options are required in the poll.",
            attributesOpacity: "You cannot have more than two attributes with less than 50% opacity.",
            borderOrBackgroundActive: "The option must have at least the active border or background.",
            confirmNewPassword: "Confirm new password",
            copyContent: "Unable to copy code",
            enterCurrentPassword: "Enter current password",
            enterEmail: "Inform the email",
            enterName: "Inform the name",
            enterNewPassword: "Enter new password",
            enterPostAuthPage: "Enter the post-authentication page",
            fileToBig: "The selected file exceeds the allowed size limit. The maximum limit is ",
            integrationServiceUnavailable: "Integration Service Unavailable",
            interactionMustHaveName: "The interaction must have a name.",
            invalidFileFormat: "Invalid file format",
            invalidTime: "Invalid time",
            loadImage: "Error loading, make sure the image is loaded and try again.",
            loadLocalsError: "Could not load the locations list. Please try again.",
            loadEstablishmentsError: "Could not load the establishments list. Please try again.",
            passwordsDontMatch: "New password and confirmation do not match",
            selectAutomationFlow: "Select an automation flow",
            selectDatabase: "Select a database",
            selectDate: "Select a date",
            selectEntryCriteria: "Select entry criteria",
            selectExternalService: "Select external service",
            selectFieldType: "Select field type",
            selectFile: "You need to select a file",
            selectList: "You must select one of the targeted lists",
            selectTrackerType: "Select tracker type",
            selectVoucher: "Select voucher",
            selectEstablishmentWeight: "Select a weight for the establishment",
            smsContentAtLeatsTwoCharacters: "Message content must be at least two characters long",
            timeoutValue: "Connection time must be at least 15 minutes",
            optionTwoCharacters: "Each option must be at least two characters long"
        }
    }
}
